// extracted by mini-css-extract-plugin
export default {"form":"Modals_form__evW5O","formItem":"Modals_formItem__RiSjZ"};